import { citySchema } from "@redotech/redo-platform-common/geographic-unit";
import * as z from "zod";

export const getCities = {
  name: "getCities" as const,
  input: z.object({ countryCode: z.string(), stateCode: z.string() }),
  output: z.array(citySchema),
};
